<template>
<el-container class="department-manage-wrap">
  <div class="headerCom">
    <publicBreadCrumb  :breadList="breadList"/>
    <publicExpandSearch padBottom='0' :searchList='searchList' :rightEventList="isAddBtnShow ? rightEventList : []" @rightFunc='rightFunc' v-on:getSearchObj='getSearchObj'></publicExpandSearch>
    <div style="position:relative">
      <el-tabs v-model="activeStatus" @tab-click="handleClick">
        <el-tab-pane label="互医机构" name="1"></el-tab-pane>
        <el-tab-pane label="线下机构" name="2" v-if="userPlatForm=='organization'"></el-tab-pane>
        <el-tab-pane label="标准科室" name="3" v-if="userPlatForm=='platForm'"></el-tab-pane>
      </el-tabs>
      <span v-if="redDataNum > 0" class="red-tag"></span>
    </div>
  </div>
  <el-main class="main-content-list">
    <!-- 标准科室 -->
    <el-table
        v-show="activeStatus === '3'"
        :data="departmentTableData"
        :header-cell-style="{textAlign: 'center',color: '#333333',fontSize: '14px', fontWeight: 'bold',backgroundColor: '#FAFAFA'}">
        <el-table-column label="序号" type="index" align="center" fixed></el-table-column>
        <el-table-column align="center" prop="name" label="一级科室名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.level === 1 ? scope.row.name : scope.row.parentName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="shortName" label="二级科室名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.level === 1 ? '--' : scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="medium" @click="handleLook(scope.row)">查看</el-button>
          <el-button type="text" size="medium" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
    </el-table-column>
    </el-table>

    <el-table
      v-show="activeStatus === '1' || activeStatus === '2'"
      :data="departmentTableData"
      :header-cell-style="{textAlign: 'center',color: '#333333',fontSize: '14px', fontWeight: 'bold',backgroundColor: '#FAFAFA'}">
      <el-table-column type="index" label="序号" align="center" fixed></el-table-column>
      <el-table-column
        v-for="(item, index) in tableOptions"
        :key="index"
        :label="item.name"
        :prop="item.label"
        resizable
        align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="item.label === 'name'" style="position:relative">
            {{ scope.row[item.label] ? scope.row[item.label] : '--'}}
            <span v-if="!scope.row.standardDepartmentId" class="red-tag-row"></span>
          </span>
          <span v-else>{{ scope.row[item.label] ? scope.row[item.label] : '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="medium" @click="handleLook(scope.row)">查看</el-button>
          <el-button type="text" size="medium" v-if="userPlatForm=='platForm'?activeStatus==1:activeStatus==2" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button v-if="activeStatus === '1' && !scope.row.top&&userPlatForm=='platForm'" type="text" size="medium" @click="handleTop(scope.row)">置顶</el-button>
          <el-button v-if="activeStatus === '1' && scope.row.top&&userPlatForm=='platForm'" type="text" size="medium" @click="handleUnTop(scope.row)">取消置顶</el-button>
          <el-button v-if="activeStatus === '2' && !scope.row.top&&userPlatForm=='organization'" type="text" size="medium" @click="handleTopOrg(scope.row)">院内置顶</el-button>
          <el-button v-if="activeStatus === '2' && scope.row.top&&userPlatForm=='organization'" type="text" size="medium" @click="handleUnTopOrg(scope.row)">取消院内置顶</el-button>
        </template>
    </el-table-column>
  </el-table>
  </el-main>
  <el-footer>
    <el-pagination
    style="text-align:right;background-color:#fff;padding-bottom:20px"
    background
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page.sync="searchParams.current"
    :page-size="searchParams.size"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>
  </el-footer>
  <AddDepartment v-if="showDialog" :showDialog.sync="showDialog" :isCancelShow="isCancelShow"  :editDepart="editDepart" :departmentForm="departmentForm" @resetObj="resetObj"/>
</el-container>
</template>
<script>
import AddDepartment from './components/AddDepartment.vue'
import {queryOrderList} from "@/api/serviceOrder"

import {
  queryPlatDepartment,
  queryOpenDepartment,
  queryStandardDepartment,
  updatePlatTopState,
  getDepartIncompleteCount,
  updateOrgTopState
} from "@/api/departmentManage"
import { DEEP_CLONE } from '@/utils/constants'
import local from '@/utils/local.js';
export default {
  components: {
    AddDepartment
  },
  data() {
    return {
      rightEventList: [{ eventName: "新增科室", eventValue: 1 }],
      searchParams: {
        current: 1,
        size: 10
      },
      breadList:[{name:'机构组织'},{name:'科室管理'}],
      searchList:[
        {
          label: "关键字搜索",
          paramName: "keyword",
          inputType: "input"
        }
      ],
      departmentForm: {
        category:1
      },
      departmentName: '',
      departmentTableData: [],
      showDialog: false,
      editDepart: true,
      options: [],
      tableOptions: [],
      options1: [
        {
          name: '一级科室名称',
          label: 'standardNameLevel1'
        },{
          name: '二级科室名称',
          label: 'standardNameLevel2'
        },{
          name: '互医机构',
          label: 'platformName'
        },{
          name: '对应标准科室',
          label: 'standardDepartmentName'
        }
      ],
      options2: [
        {
          name: '线下科室',
          label: 'name'
        },{
          name: '线下机构',
          label: 'hospitalName'
        },{
          name: '对应标准一级科室',
          label: 'standardNameLevel1'
        },{
          name: '对应标准二级科室',
          label: 'standardNameLevel2'
        }
      ],
      // options3: [
      //   {
      //     name: '一级科室名称',
      //     label: 'standardNameLevel1'
      //   },{
      //     name: '二级科室名称',
      //     label: 'standardNameLevel2'
      //   }
      // ],
      patientName: '',
      activeStatus: "1",
      // current:1,
      // size:10,
      total:0,
      orderTableData:[],
      redDataNum: 0,
      isAddBtnShow:true,
      isCancelShow:true,
      userPlatForm: "platForm", //platForm 平台 //organization 机构
      hospitalId:""
    }
  },
   created() {
   
  },
 async mounted() {
    
     this.userPlatForm = this.$store.state.userPlatForm||local.get('userPlatForm');
     if(this.userPlatForm=='organization'){
      this.hospitalId=this.$store.state.hospitalId;
       if(this.activeStatus==1){
          this.isAddBtnShow=false
       }
     }else{
       this.hospitalId="";
     }
     this.tableOptions = this.options1
     this.getTableList(1)
  },
  methods: {
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.handleAddDepart()
      }
    },
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };   
      this.getTableList();
    },
    async getRedCircle() {
      let hospitalId= this.hospitalId;
      let res = await getDepartIncompleteCount({hospitalId})
      if (res.code === 0) {
        this.redDataNum = res.data
      }
    },
    resetObj() {
      this.departmentForm = {
        ...this.departmentForm,
        // category: this.departmentForm.category,
        standardLevel1: '',
        standardLevel2: '',
        platformLevel2:"",
        platformLevel1:"",
        description: '',
        name: '',
        top: false,
        level: this.departmentForm.level,
        hospitalId: this.departmentForm.hospitalId,
        id: this.departmentForm.id,
        parentId: ''
      }
      if (!this.departmentForm.id) {
        this.$set(this.departmentForm, 'platformId', '')
        this.$set(this.departmentForm, 'hospitalId', '')
      }
      this.editDepart = true
    },
    changeEditStatus() {
      this.editDepart = true
    },
    async handleTop(row) {
      let res = await updatePlatTopState({
        id: row.id,
        top: true
      })
      if (res.code === 0) {
        this.$message.success('置顶成功')
        this.getTableList()
      } else {
        this.$message.error(res.message)
      }
    },
    async handleTopOrg(row) {
      let res = await updateOrgTopState({
        id: row.id,
        top: true
      })
      if (res.code === 0) {
        this.$message.success('置顶成功')
        this.getTableList()
      } else {
        this.$message.error(res.message)
      }
    },
    
    async handleUnTop(row) {
      let res = await updatePlatTopState({
        id: row.id,
        top: false
      })
      if (res.code === 0) {
        this.$message.success('取消置顶成功')
        this.getTableList()
      } else {
        this.$message.error(res.message)
      }
    },
    async handleUnTopOrg(row) {
      let res = await updateOrgTopState({
        id: row.id,
        top: false
      })
      if (res.code === 0) {
        this.$message.success('取消置顶成功')
        this.getTableList()
      } else {
        this.$message.error(res.message)
      }
    },
    handleAddDepart() {
      this.departmentForm = {
        category: Number(this.activeStatus),
        platformId: '',
        standardLevel1: '',
        standardLevel2: '',
        description: '',
        name: '',
        top: false,
        level: '',
        hospitalId: '',
        parentId: ''
      }
      this.showDialog = true
      this.editDepart = true
    },
    handleLook(row) {
      this.departmentForm = DEEP_CLONE(row)
      if (this.activeStatus === '1') {
        // this.departmentForm.category = 1
        this.$set(this.departmentForm, 'category', 1)
      }
      if (this.activeStatus === '2') {
        this.$set(this.departmentForm, 'category', 2)
      }
      if (this.activeStatus === '3') {
        this.$set(this.departmentForm, 'category', 3)
      }
    
      if(this.userPlatForm=="organization"&&this.departmentForm.category==1){
        this.isCancelShow=false
        
      }else{
        this.isCancelShow=true
      }
        this.showDialog = true
      this.editDepart = false
     
    },
    handleEdit(row) {
      this.departmentForm = DEEP_CLONE(row);
      if (this.activeStatus === '1') {
        // this.departmentForm.category = 1
        this.$set(this.departmentForm, 'category', 1)
      }
      if (this.activeStatus === '2') {
        this.$set(this.departmentForm, 'category', 2)
      }
      if (this.activeStatus === '3') {
        this.$set(this.departmentForm, 'category', 3);
        this.departmentForm.category=3;
      }
      this.showDialog = true
      this.editDepart = true
    },

    handleReset() {
      this.departmentName = ''
      this.getTableList(1)
    },
    handleSizeChange(val) {
      this.searchParams.size = val
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.searchParams.current = val
      this.getTableList()
    },
    handleClick(tab) {
      if (this.activeStatus === '1') {
        this.tableOptions = this.options1
      }
      if (this.activeStatus === '2') {
        this.tableOptions = this.options2
      }
     if(this.userPlatForm=='organization'){
       if(this.activeStatus==1){
          this.isAddBtnShow=false
       }else{
          this.isAddBtnShow=true
       }
     }
      // if (this.activeStatus === '3') {
      //   this.tableOptions = this.options3
      // }
      this.getTableList(1)
    },
    async getTableList(flag) {
      await this.getRedCircle()
      // if (flag === 1) {
      //   this.current = 1
      //   this.size = 10
      // }
      // 平台
      if (this.activeStatus === '1') {
        let res = await queryPlatDepartment({
          current: this.searchParams.current,
          size: this.searchParams.size,
          keyword: this.searchParams.keyword
        })
        if (res.code === 0) {
          this.departmentTableData = res.data.records
          this.total = res.data.total
        }
      }
      // 开放
      if (this.activeStatus === '2') {
        let res = await queryOpenDepartment({
          current: this.searchParams.current,
          size: this.searchParams.size,
          keyword: this.searchParams.keyword
        })
        if (res.code === 0) {
          this.departmentTableData = res.data.records
          this.total = res.data.total
        }
      }
      // 标准
      if (this.activeStatus === '3') {
        let res = await queryStandardDepartment({
          current: this.searchParams.current,
          size: this.searchParams.size,
          keyword: this.searchParams.keyword
        })
        if (res.code === 0) {
          this.departmentTableData = res.data.records
          this.total = res.data.total
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.red-tag {
  display: block;
  width: 8px;
  height: 8px;
  background: #F14352;
  border-radius: 7px;
  position: absolute;
  top: 8px;
  left: 87px;
}
.red-tag-row {
  display: block;
  width: 6px;
  height: 6px;
  background: #F14352;
  border-radius: 7px;
  position: absolute;
  top: 7px;
  left: -10px;
}
/deep/.el-tabs__header {
  margin: 15px 0 0 0;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: #FFFFFF;
}
.main-content-list {
  padding: 15px;
  background-color: #fff;
  margin: 0 16px;
}
.department-manage-wrap {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-btns {
    text-align: left;
  }
  .active-bg {
    background-color: #FCFCFC;
    // border: 1px dashed #1A7BFC;
  }
  // .el-header {
  //   // padding: 23px 24px;
  //   height: 68px;
  //   background: #FFFFFF;
  // }
  // .menu-name {
  //   font-size: 14px;
  //   font-weight: 400;
  //   color: #333333;
  //   text-align: left;
  //   padding-bottom: 16px;
  // }
  /deep/.el-table__header th {
    padding: 0;
    height: 54px;
  }
  .btn-bg {
    background-color: #1A7BFC;
  }
  .el-button--text {
    color: #1A7BFC;
  }
}
.el-button.is-disabled.el-button--text {
  color: #999999;
}
.table-wrap {
  padding: 15px 16px;
  padding-bottom: 0px;
  background-color: #FFFFFF;
}
/deep/.el-table td, .el-table th {
  padding: 8px 0;
}
</style>
<style lang="less">
.message-del-confirm {
  .el-button--primary {
    background-color: #1A7BFC;
  }
}
</style>

